import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { ExamService } from '../../../../Services/examServices';
import Auth from '../../../../auth/auth';
import { defaultTheme, PageShell, TopBar, UserChip, NxButton, NxIcon } from '../../../../components/nx';

const t = defaultTheme;

const StudentInfo = () => {
    const navigate = useNavigate();
    const [userInfo, setUserInfo] = useState<any>();

    async function getUserInfoWithoutExams() {
        try {
            const res = await ExamService.getUserInfoWtihoutExams();
            if (res.status === 200) {
                setUserInfo(res.data.data);
                toast.success("Data fetched successfully");
            }
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => { getUserInfoWithoutExams(); }, []);

    return (
        <PageShell t={t} style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
            <TopBar t={t} crumbs={['Verify Information']} right={<UserChip t={t} onLogout={() => { Auth.signout(); navigate('/login'); }} />} />

            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 40 }}>
                <div style={{
                    width: '100%', maxWidth: 600,
                    background: t.surface, border: `1px solid ${t.border}`, borderRadius: 14,
                    overflow: 'hidden',
                }}>
                    <div style={{
                        padding: '20px 28px', borderBottom: `1px solid ${t.border}`,
                        background: t.paperAlt,
                    }}>
                        <h2 style={{ fontSize: 16, fontWeight: 500, color: t.ink, margin: 0 }}>Verify Your Information</h2>
                        <p style={{ fontSize: 12, color: t.warning, margin: '6px 0 0' }}>
                            If you find any issues in the below information, contact your invigilator.
                        </p>
                    </div>

                    <div style={{ padding: 28 }}>
                        {userInfo && userInfo.studentInfo?.map((data: any, idx: number) => (
                            <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                                    {[
                                        { label: 'Name', value: `${data?.name || ''} ${data?.last_name || ''}`.trim() },
                                        { label: 'Email', value: data?.email },
                                        { label: 'Reg Number', value: data?.registrationNumber || '---' },
                                        { label: 'Membership Number', value: data?.membershipNumber || '---' },
                                    ].map((item, i) => (
                                        <div key={i}>
                                            <div style={{ fontSize: 10, letterSpacing: '0.08em', textTransform: 'uppercase', color: t.inkMute, fontWeight: 600, marginBottom: 2 }}>
                                                {item.label}
                                            </div>
                                            <div style={{ fontSize: 14, fontWeight: 500, color: t.ink }}>{item.value}</div>
                                        </div>
                                    ))}
                                </div>
                                {data?.image && (
                                    <div style={{
                                        width: 100, height: 100, borderRadius: 10,
                                        border: `1px solid ${t.border}`, overflow: 'hidden', flexShrink: 0,
                                    }}>
                                        <img src={data.image} alt="Profile" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    </div>
                                )}
                            </div>
                        ))}

                        <div style={{ marginTop: 28 }}>
                            <NxButton t={t} kind="primary" icon={NxIcon.arrowRight('#fff')} onClick={() => navigate("/exam/instructions-new")}>
                                Verify and continue
                            </NxButton>
                        </div>
                    </div>
                </div>
            </div>
        </PageShell>
    );
};

export default StudentInfo;
